import PropTypes from "prop-types";
import React, { Fragment } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { PopoverBody } from "reactstrap";

// import FormCheckbox from "../../../components/form/FormCheckbox";
import FormButton from "../../../components/form/FormButton";
import FormTextField from "../../../components/form/FormTextField";
import ModalField from "../../../components/modal/ModalField";
import ModalRow from "../../../components/modal/ModalRow";
import NavigationToolbar from "../../../components/navigationToolbar";
import { popoverOrPortal } from "../../../components/portal/popoverOrPortal";
import { withScreenContext } from "../../../components/screen/ScreenContext";
import { isScreenModeMobile } from "../../../constants/screenModes";
import floatToInt from "../../../utils/floatToInt";

const eraseNonMultiples = arr => {
  for (let i = 1; i < arr.length; i++) {
    if (arr[i] % arr[i - 1] !== 0) {
      return arr.slice(0, i);
    }
  }
  return arr;
};

class CalendarSettingsEraTopRowView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popoverOpen: false
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
  }

  renderPopoverContents() {
    const leap1 = this.props.leapCycles.size >= 1 ? this.props.leapCycles.get(0) : null;
    const leap2 = this.props.leapCycles.size >= 2 ? this.props.leapCycles.get(1) : null;
    const leap3 = this.props.leapCycles.size >= 3 ? this.props.leapCycles.get(2) : null;

    const onChangeLeapCycle = (index, value) => {
      let newCycles = this.props.leapCycles.toArray();
      // if there is no number, then erase everything after this index
      if (!value) {
        newCycles = index === 0 ? [] : newCycles.slice(0, index);
      } else {
        const numValue = floatToInt(Number(value));
        if (index < newCycles.length) {
          newCycles[index] = numValue;
        } else {
          newCycles.push(numValue);
        }
        newCycles = eraseNonMultiples(newCycles);
      }
      this.props.onChangeLeapCycles(newCycles);
    };

    return (
      <div className="editLeapYearsPopoverContent">
        <div className={`toolbarPopoverHeading`}>Leap years occur:</div>
        <ModalRow>
          <ModalField label="Every">
            <FormTextField
              value={leap1}
              numeric={true}
              isInteger={true}
              onChange={value => onChangeLeapCycle(0, value)}
              min={2}
              disabled={!this.props.canEditDateData}
              placeholder="None"
            />
            <span className="editLeapYearsHint">{leap1 ? `(${leap1}, ${leap1 * 2}, ${leap1 * 3}...)` : ""}</span>
          </ModalField>
        </ModalRow>
        <ModalRow>
          <ModalField label="except every">
            <FormTextField
              value={leap2}
              numeric={true}
              isInteger={true}
              onChange={value => onChangeLeapCycle(1, value)}
              min={leap1 * 2}
              disabled={!leap1 || !this.props.canEditDateData}
            />
            <span className="editLeapYearsHint">{leap2 ? `(${leap2}, ${leap2 * 2}, ${leap2 * 3}...)` : ""}</span>
          </ModalField>
        </ModalRow>
        <ModalRow>
          <ModalField label="but also every">
            <FormTextField
              value={leap3}
              numeric={true}
              isInteger={true}
              onChange={value => onChangeLeapCycle(2, value)}
              min={leap2 * 2}
              disabled={!leap2 || !this.props.canEditDateData}
            />
            <span className="editLeapYearsHint">{leap3 ? `(${leap3}, ${leap3 * 2}, ${leap3 * 3}...)` : ""}</span>
          </ModalField>
        </ModalRow>
        <div className={`toolbarPopoverExplanation`}>Note: Every value must be multiple of previous value</div>
      </div>
    );
  }

  renderPopover() {
    let placement = "bottom-start";
    let hideArrow = false;
    let alwaysPortal = false;
    //#!if tablet === true
// placement = "right-start";
    //#!endif

    let popoverOptions = {
      className: `inspectorPopover`,
      placement,
      hideArrow,
      isOpen: this.state.popoverOpen,
      target: "editLeapYearButton",
      toggle: null
    };

    const child = (
      <Fragment>
        {this.props.screenContext && isScreenModeMobile(this.props.screenContext.screenMode) ? (
          <NavigationToolbar
            title="Leap Years"
            showBack={true}
            showBackArrow={true}
            onBackClick={this.toggle}
            backText="Back"
            flexLeft={1}
            flexCenter={3}
            flexRight={1}
          />
        ) : null}
        <PopoverBody onClick={e => e.stopPropagation()}>{this.renderPopoverContents()}</PopoverBody>
      </Fragment>
    );

    return popoverOrPortal(child, popoverOptions, alwaysPortal);
  }

  render() {
    return (
      <div className="calendarEraTopRow">
        <div />
        {/* <FormCheckbox
          label="Don't use eras (count years as -1, 0, 1, 2...)"
          checkboxState={this.props.ignoreEras}
          onChange={value => this.props.onChangeIgnoreEras(value)}
          disabled={!this.props.canEditDateData}
        /> */}
        <FormButton id="editLeapYearButton" label="Customize leap years" linkStyle={true} onClick={this.toggle} />
        {this.state.popoverOpen ? <div className="formListBackdrop" onClick={this.toggle} /> : null}
        {this.state.popoverOpen ? this.renderPopover() : null}
      </div>
    );
  }
}

CalendarSettingsEraTopRowView.propTypes = {
  ignoreEras: PropTypes.bool.isRequired,
  leapCycles: ImmutablePropTypes.listOf(PropTypes.number).isRequired,
  onChangeIgnoreEras: PropTypes.func.isRequired,
  onChangeLeapCycles: PropTypes.func.isRequired,
  canEditDateData: PropTypes.bool.isRequired,

  // From withScreenContext
  screenContext: PropTypes.object
};

let exportedView = CalendarSettingsEraTopRowView;
//#!if iOS === true
// exportedView = withScreenContext(CalendarSettingsEraTopRowView);
//#!endif
export default exportedView;
